import { AuthApi } from "./api"
import { isOnPage } from "./Helpers"



const redirectToAuth = (company, dispatch) => { 
  let promoCode = sessionStorage.getItem("promoCode");
  if (company === "1" || company.toUpperCase() === "T-MOBILE") {
    window.location.href = process.env.REACT_APP_TMO_ID_AUTH_URL
  } else if (company === "2" || company.toUpperCase() === "SPRINT" ) {    
    if(isOnPage('ooma') ||  isOnPage('amazon') || isOnPage('google') || promoCode === "2022YOUTUBETV"){
      dispatch({type: "MISCERROR", payload: {ooma: 'Sprint customers are not eligible for this offer'}})
      return
    }
    const form = document.createElement("form")
    form.method = "post"
    form.action = process.env.REACT_APP_SPRINT_SSO_URL
    document.body.appendChild(form)
    form.submit()
  }
}

const defaultLookupValues = (phoneNumber, company) => ({phoneNumber, company})

function baseCompanyLookupFactory(before, onCompanyNotFound, dispatch, getLookupValues = defaultLookupValues) {
  //reset miscError
  dispatch({type: "MISCERROR", payload: {}})

  return async (phoneNumber) => {
    before()
    const response = await AuthApi.getCompanyLookup(phoneNumber)
    const company = response.company !== undefined ? response.company.toString() : response

    if (!company || company === "NotFound" || company === "0") {
      onCompanyNotFound()
    } else {
      let lookupValues = getLookupValues(phoneNumber, company)
      dispatch({type: "SETLOOKUPVALUES", payload: lookupValues})

      redirectToAuth(company, dispatch)
    }
  }
}

export const companyLookupFactory = (before, onCompanyNotFound, dispatch) => async (
  phoneNumber,
  actions
) => {
  await baseCompanyLookupFactory(before, onCompanyNotFound, dispatch)(phoneNumber)
  actions.setSubmitting(false)
}

export const promoCodeCompanyLookup = (before, onCompanyNotFound, dispatch) => async (
  phoneNumber,
  actions,
  promoCode
) => {
  const getLookupValues = (phoneNumber, company) => ({phoneNumber, company, promoCode})
  await baseCompanyLookupFactory(before, () => onCompanyNotFound(promoCode), dispatch, getLookupValues)(phoneNumber)

  actions.setSubmitting(false)
}
